import { render } from "./sqmExperimentRecordDetail.vue?vue&type=template&id=06297996&scoped=true"
import script from "./sqmExperimentRecordDetail.vue?vue&type=script&lang=js"
export * from "./sqmExperimentRecordDetail.vue?vue&type=script&lang=js"

import "./sqmExperimentRecordDetail.vue?vue&type=style&index=0&id=06297996&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06297996"]])

export default __exports__